import {
  createBrowserRouter,
  RouteObject,
  RouterProvider,
} from "react-router-dom";
import { adminRouter } from "./routes/adminRoutes";
import { router } from "./routes/routes";
import { websiteRouter } from "./routes/websitePageRoutes";
import { shouldNotUseSubDomain } from "./utils/constants";

const getRouter = () => {
  const domain = window.location.hostname;

  let r: RouteObject[] = [];

  if (domain.startsWith("app.")) {
    // Load only client app routes in "app.*" subdomain
    r = router;
  } else if (domain.startsWith("admin.")) {
    // Load only admin app routes in "admin.*" subdomain
    r = adminRouter;
  } else if (shouldNotUseSubDomain) {
    // Load all app routes in
    r = [...websiteRouter, ...adminRouter, ...router];
  } else {
    // Load client app as fallback
    r = websiteRouter;
  }

  return createBrowserRouter(r);
};

function App() {
  return (
    <>
      <RouterProvider router={getRouter()} />
    </>
  );
}

export default App;
